<template>
  <div :index='index' v-if="apidata">
    <div v-if="toggleVal != 'contributions' && issueActive === true" class='text'>
      <typewriter
      class='noMargin darkgrey'
      :speed="100"
      :full-erase="false"
      :interval="2000"
      :words='[issue.title.toUpperCase()]'>
      Issue {{issue.number-1}}: 
      </typewriter>
      <typewriter
      class='footerLink darkgrey'
      :speed="100"
      :full-erase="false"
      :interval="2000"
      :words='[locationsOutput.toUpperCase()]'>
      @ 
      </typewriter>

      <transition-group name="fade">
      <div key="dynamic" class='animation' v-if="issueActiveInfo === true">
        <div v-if="issue.desc && toggleVal === 'info'" v-html="issue.desc"></div>
        <div v-else-if="issue.text && toggleVal === 'letter'" v-html="issue.text"></div>
        <div class='' v-if="toggleVal === 'issue' && issue.availability == 'available'">
              <p style='margin-bottom: 0' class='contributions_textarea_big'>Issue {{issue.number.toUpperCase()}}: {{issue.title.toUpperCase()}}</p>
              <p class='noMargin contributions_textarea_big'>{{issue.year}}</p>
              <br>
              <p v-if="issue.pages" class='noMargin'>{{issue.pages}} pages</p>
              <p v-if="issue.width" class='noMargin'>{{issue.width}}mm wide</p>
              <p v-if="issue.height" class='noMargin'>{{issue.height}}mm high</p>
              <p class='noMargin'>Cold glue, handbound</p>
              <br>
              <p style='margin-top: 0' :class="{issue_soldout: issue.availability == 'sold-out'}">
              We currently don't support e-commerce and so orders have to be placed via email<br> Publication cost €{{issue.price}}  + shipping<br> Order via <a class='inline' href='mailto:fanfarefanfare@fanfarefanfare.nl' style='text-decoration: underline'>email</a> 
              </p>
        </div>
      </div>
      </transition-group>
    </div>      

    <transition-group name="fade">
      <Dog key="dynamic" class='animation' @click.native="instructionFunc" v-if="showDog === true" :class="{dogOuter_show: selected === null && $store.state.instruction === true}"></Dog>
    </transition-group>

    <transition-group name="fade">
      <Cloud key="dynamic" class='animation' @click.native="instructionFunc" v-if="showDog === true" :class="{dogOuter_show: selected === null && $store.state.instruction === true}"></Cloud>
    </transition-group>


    <div v-if="toggleVal === 'contributions'">
      <div v-if="showDog === false">
        <div @mouseleave="mouseLeave" @mouseover="mouseEnter" class='contribution_upper'>
        <multiselect
          v-model="selected"
          :options="options"
          :searchable="true"
          placeholder="Search contributors"
          :close-on-select="false"
          :loading="true"
          @open="reset"
          @close="resetRemove"
        >
        </multiselect>
        </div>

        <!-- <div class='contributions' v-if="!toggleVal" v-bind:style="contributionsMargin()"> -->
          <div class='contributions'  v-bind:style="contributionMargin()">
          <div v-if="!contributions.length" class='text issue_warning'>
            No added contributions to {{issue.title.toUpperCase()}} yet
          </div>

          <div v-if="searchCheck()" class='text issue_warning'>
            No added contribution found for {{selected.toUpperCase()}}<br>Contact the admin to get this bug fixed
          </div>

          <div class='contributions_wrapper'>
            <div 
              v-for="(contribution, key) in contributions" 
              v-if="contributionCheck(contribution)"
              :class="contributionClass(contribution)" 
              class='contributions_inner'
            >

              <span class="contributions_inner_el" v-if="contribution.type === 'singleimg'">
                <p v-if="contribution.type === 'singleimg'">{{contribution.name.toUpperCase()}}</p> 
                <p class="contributions_inner_el_fixed" v-if="contribution.type === 'singleimg'">image</p>
              </span>

              <router-link 
                class="contributions_text contributions_inner_text" 
                v-if="contribution.type === 'text'"
                :to="{ name: 'IssueInner', params: { id: uid(contribution) }}"
                style='cursor: pointer'
              >
                <p v-if="contribution.type === 'text'">{{contribution.name.toUpperCase()}}</p> 
                <div v-html='textPreview(contribution.text)'></div>
              </router-link>

              <div
                v-if="contribution.type === 'singleimg'"
                :class="contribution.orientation"
                @click="imagePreview(contribution.url, contribution.orientation)"
              >
              </div>

              <div
                v-if="contribution.type != 'text' && contribution.type != 'singleimg'"
                v-for="(innerContribution, key) in contribution"
                class="contributions_carousel_inner"
                :class="innerContribution.orientation"
                @click="imagePreview(innerContribution.url, innerContribution.orientation)"
              >
                <span class="contributions_inner_el" v-if="key === 0">
                  <p v-if="contribution.type === 'singleimg'">{{contribution.name.toUpperCase()}}</p> 
                  <p v-else-if="contribution.type != 'singleimg' && contribution.type != 'text'">{{contribution[0].name.toUpperCase()}}</p> 
                  <p class="contributions_inner_el_fixed" v-if="contribution.type === 'singleimg'">image</p>
                  <p class="contributions_inner_el_fixed" v-else-if="contribution.type != 'singleimg' && contribution.type != 'text'">images</p> 
                </span>
              </div>

            </div>
          
          </div>
        </div>

        <div class='text issue_funding' v-if="issue.possponsors.length && selected === null">
          <span v-if="issue.possponsors.length && selected === null">
          FUNDING GRANTED BY {{issue.possponsors.join(", ")}}
          </span>
          <span v-if="issue.negsponsors.length  && selected === null">
          FUNDING REJECTED BY {{issue.negsponsors.join(", ")}}
          </span>
        </div>

        <Balloon @click.native="balloonFunc" :title="'CLEAR FILTER'"></Balloon>
      
        <transition-group name="fade">
          <div class="issue_preview_outer animation" key="dynamic" v-if="image" v-prevent-parent-scroll>
            <div key="main-content" class="issue_preview_inner animation" :class="previewClass()" v-bind:style="{ backgroundImage: 'url(' + image + ')' }">
            </div>
            <div id='cursor' class='issue_preview_close button' @click="imageHide"><span>close</span></div>
          </div>
        </transition-group>
      </div>
    </div>

    <div class="buttonHolder" v-if="issueActiveInfo === true && selected === null && hideNav && showDog === false">
      <div v-if="issue.desc" v-on:click="toggle('info')" :class="{buttonActive: toggleVal === 'info'}" class="button buttonNav"><span>INTRO<wbr>DUCTION</span></div>
      <div v-if="issue.text" v-on:click="toggle('letter')"  :class="{buttonActive: toggleVal === 'letter'}" class="button buttonNav"><span>LETTER TO SPONSOR</span></div>
      <div v-if="contributions.length" v-on:click="toggle('contributions')"  :class="{buttonActive: toggleVal === 'contributions'}" class="button buttonNav"><span>CONTRIBU<wbr>TIONS</span></div>
      <div v-on:click="toggle('issue')" v-if="issue.availability == 'available'"  :class="{buttonActive: toggleVal === 'issue'}" class="button buttonNav"><span>BUY ISSUE</span></div>
    </div>
    

  </div>
</template>

<script>
import Bird from './library/bird.vue'
import _ from 'underscore'
import Multiselect from 'vue-multiselect'
import Balloon from './library/balloon.vue'
import Dog from './library/dog.vue'
import Cloud from './library/sun.vue'

export default {
  name: 'Issue',
  props: ['index'],
  components: {
      Multiselect,
      Balloon,
      Dog,
      Cloud
  },
  data () {
    return {
      selected: null,
      toggleVal: false,
      hideNav: true,
      image: false,
      orientation: false,
      issueActive: true,
      issueActiveInfo: false,
      showDog: false
    }
  },
  computed: {
    apidata () {
      return this.$store.state.apidata
    },
    siteImg () {
      return _.values(this.apidata['4-images'])
    },
    siteImgAr () {
      return this.siteImg[0]
    },
    randSiteImg () {
      return this.siteImgAr[this.issue.number - 1]
    },
    issues () {
      return this.apidata['1-issues']
    }, 
    issue () {
      return this.issues[this.index]
    },
    locations () {
      return this.issue.locations
    },
    locationsOutput () {
      if(this.locations.length > 1) {
        return this.locations.slice(0, -1).join(", ") + " & " + this.locations.slice(-1).pop()
      } else if (this.locations.length > 0) {
        return this.issue.locations[0]
      } else {
        return " "
      }
    },
    options () {
      const cont = _.sortBy(this.issue.contributors, 'sortLetter')
      return _.pluck(cont, 'name')
    },
    activeOptions () {
      return this.$store.state.issueFilter
    },
    contributions () {
      const imagesSingle = _.compact(this.issue.imageContributionsSingle)
      const imagesDouble = _.compact(this.issue.imageContributionsCarousel)
      const text = _.compact(this.issue.textContributions) 
      const contributionsArr = [].concat(imagesSingle, imagesDouble, text)

      return _.shuffle(contributionsArr)
    },
    activeContributors () {
      const flaten = _.flatten(this.contributions)
      const names = _.pluck(flaten, 'name')
      const unique = _.uniq(names)
      return _.compact(unique)
    },
    storeClassBody () {
      return this.$store.state.classBody
    },
    issueInfoShow: function () {
      const timeOut1 = this.issue.title.length
      const timeOut2 = this.issue.locations.join('').length
      if(timeOut1 > timeOut2) {
        return timeOut1 * 100 + 500
      } else {
        return timeOut2 * 100 + 500
      }
    },
    menuClick () {
      return this.$store.state.menuClick
    }
  },
  methods: {
      mouseLeave: function() {
        if(this.hideNav === false) {
          const menu = document.getElementsByClassName("multiselect__content-wrapper")
          const el = menu[0]
          el.style.display = "none"
          
        }
      },
      mouseEnter: function() {
        if(this.hideNav === false) {
          const menu = document.getElementsByClassName("multiselect__content-wrapper")
          const el = menu[0]
          el.style.display = "block"
        }
      },
      mouseMove: function (event) {
        const cursor = document.getElementById("cursor");
        console.log(event.pageX)
        cursor.style.left = event.pageX + 12 + "px";
        cursor.style.top = event.pageY - 10.5 + "px";
      }, 
      toggle: function (val) {
        // console.log(this.toggleVal)
        if(this.toggleVal != val) {
          this.toggleVal = val
          window.scroll(0,0)
        }
      }, 
      uid: function (element) {
        if(element.type === 'text') {
          return element.name.split(' ').join('-').toLowerCase() + "-" + "text"
        } else if (element.type === 'singleimg') {
          return element.name.split(' ').join('-').toLowerCase() + "-" + "image"
        } else {
          return element[0].name.split(' ').join('-').toLowerCase() + "-" + "images"
        }
      },
      contributionCheck: function (val) {
        if( _.pluck(val, 'name') != false ) {
          const name = val.name
          const alt = _.pluck(val, 'name')
          const contributors = this.issue.contributors.length
          if(this.selected === null && this.activeOptions === false || this.activeOptions.length === contributors && this.selected === null) {
          // if(this.selected === null || this.selected === null && contributors === this.activeOptions.length || this.activeOptions === false) {
            return true
          } else if (_.contains(this.activeOptions, name) && contributors != this.activeOptions.length) {
            return true
          } else if (_.contains(this.activeOptions, alt[0]) && contributors != this.activeOptions.length) {
            return true
          } else if (name != undefined && this.selected === name) {
            return true
          } else if (_.contains(alt, this.selected)) {
            return true
          } else if (_.contains(this.activeContributors, val) === false && this.falseSearchResult === true) {
            return true
          } else {
            return false
          }

        }
      },
      reset: function () {
        this.selected = null
        // this.toggleVal = false
        this.hideNav = false
        window.scroll(0,0)
      }, 
      resetRemove: function () {
        this.hideNav = true
      },
      searchCheck: function () {
        if (this.selected != null && _.contains(this.activeContributors , this.selected) === false) {
          this.falseSearchResult = true
          return true
        }
      },
      KeyListener: function (evt) {
        if (evt.keyCode === 27) { 
          this.selected = null
          // this.toggleVal = false
          this.image = false

          const menu = document.getElementsByClassName("multiselect__content-wrapper")
          const el = menu[0]
          el.style.display = "none"
        }
      },
      contributionClass: function (element) {
        if(element.type) {
          return "contributions_" + element.type
        } else {
          return "contributions_carousel"
        }
      },
      textPreview: function (val) {
        const split = val.split(" ")
        const select = _.first(split, 14) 

        return select.join(" ") + ' ...'
      },
      imagePreview: function (url, orientation) {
        if(this.image != url ) {
          this.image = url
          this.orientation = orientation
        } else {
          this.image = false
          this.orientation = false
        }
      },
      imageHide: function() {
        this.image = false
        this.orientation = false
      },
      balloonFunc: function () {
        this.selected = null
        this.image = false
      },
      instructionFunc: function () {
        this.$store.state.instruction = false
        this.$store.state.menuInstruction = false
        this.showDog = false
      },
      previewClass: function () {
        if(this.image != false) {
          return 'issue_preview_active' + ' ' + 'issue_preview_'+this.orientation
        }
      },
      randStyle: function (num) {
        const left = num + 5 
        const rotate = num *80/4/100*5 

        if (rotate > 25 && rotate < 40) {
          if(this.$store.state.instruction === false) {
            return {
              left: left + 'px',
              transform: "rotate(" + '-'+num *80/4/100*3 +'deg) scale(.8)',
              top: '-' + 70 + num * 0.3 + 'px'
            }
          } else {
            return {
              left: left + 'px',
              transform: "rotate(" + '-'+num *80/4/100*4 +'deg)',
              top: '-' + 70 + num * 0.3 + 'px'
            }
          }
        } else {
          if(this.$store.state.instruction === false) {
            return {
              left: left + 'px',
              transform: "rotate(" + num *80/4/100*3 +'deg) scale(.8)',
              top: '-' + 70 - num * 1.3 + 'px'
            }
          } else {
            return {
              left: left + 'px',
              transform: "rotate(" + rotate +'deg)',
              top: '-' + 70 - num * 1.3 + 'px'
            }
          }
        }
      },
      bubbleHide: function (el) {
        console.log(el)
        el.target.style.display = "none"
        el.target.style.pointerEvents = "none"
      },
      bubbleContains: function () {
        return true
      },
      contributionMargin: function () {
        if(this.selected === null) {
          return {
            paddingBottom: "30px"
          }
        }
      },
      setToggleVal: function () {
        if(this.$store.state.previousRoute === 'issueInner') {
          this.toggleVal = 'contributions'
          this.$store.state.previousRoute = false
        }
        else if(this.toggleVal === false){
          if(this.issue.desc.length) {
            this.toggleVal = 'info'
          } else {
          this.toggleVal = 'letter'
          }
        }
      }
  },
  watch: {
    selected: function () {
      this.falseSearchResult = false
      // this.toggleVal = false
      this.$store.state.selectedVal = this.selected
      this.$store.state.instruction = false
    },
    issue: function () {
      this.toggleVal = false
      this.selected = null
      this.image = false
      window.scroll(0,0)
      this.issueActive = false;
      this.issueActiveInfo = true;
      var self = this;
      setTimeout(function(){
          self.issueActive = true;
      }, 10);
      this.issueActiveInfo = false;
      var self2 = this;
      setTimeout(function(){
          self2.issueActiveInfo = true;
      }, this.issueInfoShow );
    },
    activeOptions: function () {
      this.contributionCheck()
    },
    image: function () {
      this.$store.state.instruction = false
    },
    menuClick: function () {
      this.setToggleVal()
    },
    toggleVal: function () {
      if(this.toggleVal === 'contributions' && this.$store.state.instruction === true) {
        this.showDog = true
        this.$store.state.menuInstruction = false
        this.$store.state.menuInstruction = true
        const time = Math.floor(Math.random() * 5000) + 2500  
        var self = this;
        var self2 = this;
        setTimeout(function(){
          self.showDog = false
          self2.$store.state.menuInstruction = false
        }, time);
      }
    }
  },
  beforeCreated: function () {
    this.$store.state.issueFilter = false
    this.selected = null
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    vm.$store.state.classBody = 'issue'
    })
  },
  mounted: function () {
    this.$store.state.classBody = 'issue'
    this.$store.state.compass = false
    this.$store.state.issueFilter = false
    this.selected = null
    this.contributionCheck()
    this.setToggleVal()
    var self2 = this;
    setTimeout(function(){
        self2.issueActiveInfo = true;
    }, this.issueInfoShow );


  },
  updated: function () {
    this.$store.state.classBody = 'issue'
    this.contributionCheck()
    document.addEventListener('keyup', this.KeyListener)
    this.setToggleVal()
  },
  destroyed () {
    document.removeEventListener('keyup', this.KeyListener)
    this.$store.state.issueFilter = false
    this.$store.state.classBody = ' '
    this.selected = null
  },
  beforeRouteLeave (to, from, next) {
      this.$store.state.previousRoute = 'issue'
      const time = Math.floor(Math.random() * 200) + 10  
      this.$store.state.compass = true 
      this.selected = null
      setTimeout(function(){ next() }, time)
  } 
}
</script>

<style lang="less">
@import "../styles/global.less";
  .contribution_upper {
    max-width: 100vw;
    overflow-x: hidden 
  }
  
  .multiselect {
    position: relative;
    margin: 0 auto;
    width: calc(~"@{breakpoint1} - 40px");

    // transform: translate(-50%, -50%);
    padding: 0;
    z-index: 1000000;
    top: 0;
    &__select {
      position: fixed;
      width: 40px;
      height: 42px;
      right: calc(~" 50% - @{breakpoint1} / 2 + 20px");
      top: 20px;
      z-index: 10000000;
      margin-top: 8px;
      padding: 20px 10px 20px 10px;
      text-align: center;
      transition: -webkit-transform .2s ease;
      transition: transform .2s ease;
      transition: transform .2s ease,-webkit-transform .2s ease;
      transform-origin: 50% 50%;
      &:before {
          position: relative;
          top: 4px;
          color: @black;
          margin-top: 5px;
          border-style: solid;
          border-width: 6px 6px 0;
          border-color: @black transparent transparent;
          content: "";
      }
    }

    &--active {
      .multiselect__select {
        transform: rotate(180deg);
      }
    }

    &__input, &__content, &__element {
      color: @black;
      .fs-l;
      letter-spacing: 1.8px;
      font-family: 'scarlaregular'; 
    }

    &__input {
      position: fixed;
      width: calc(~"@{breakpoint1} - 40px");
      z-index: 1000000;

      top: 20px;

      color: @black; 
      padding: @mp-a @mp-a/2;
      user-select: none;
      border: 0px;
      border-radius: 0px !important;
      margin: @mp-a 0;

      box-shadow: -5px 2px 40px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 10px rgba(0, 0, 0, 0.3), 0 10px 20px 20px rgba(0, 0, 0, 0.2), -1px 0px 4px  rgba(0, 0, 0, 0.2) !important;
      &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: @black;
      }
      &::-moz-placeholder { /* Firefox 19+ */
      color: @black;
      }
      &:-ms-input-placeholder { /* IE 10+ */
      color: @black;
      }
      &:-moz-placeholder { /* Firefox 18- */
      color: @black;
      }
    }

     &__content {
      width: 100%;
      padding: 0;
      margin-top: 74px;
      text-align: center;
    }

    &__element {
      width: 100%;
      margin: @mp-a/2 0;
     
      user-select: none;

      transition: .05s;
      cursor: pointer;

      position: relative;
    }

    textarea:focus, input:focus{
    outline: none;
    }

    &__option {
      .fs-l;
      letter-spacing: .8px;
      width: 100%;
      display: block;
    }

    &__content-wrapper {
      height: auto;
    }

    .multiselect__option--selected {
      text-decoration: underline;
    }
  }

  .issue {
    &_annoucement {
      .fs-l;
      color: @black;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 900000000;
      letter-spacing: 1.5px;
      width: 200px;
      text-align: center;
    }
    &_base {
      // color: @midgrey;
      // background: @darkgrey;
    }
    &_image {
      width: 280px;
      margin: 0 auto;
      display: block;
    }
    &_negative {
      color: @midgrey;
      // background: @darkgrey;
    }
    &_positive {
      color: @black;
    }
    &_soldout {
      color: @darkgrey;
      a {
        pointer-events: none;
      }
    }
    &_warning {
      text-align: center; 
      letter-spacing: 1.8px !important;
      .fs-l !important;
      margin: @mp-d 0 @mp-e 0;
      margin-left: @mp-b;
      width: calc(~"100vw - 40px");
    }
    &_footer {
      color: @darkgrey;
    }
    &_funding {
      margin-bottom: @mp-b !important;
      span {
      text-align: center;
      position: relative;
      color: @darkgrey;
      padding-left: @mp-c !important;
      font-size: 15px;
      padding-bottom: 0 !important;
      display: block;
      }
    }
    &_preview {
      position: fixed;
      left: 0;
      top: 0;
      &_close {
        position: fixed;
        letter-spacing: .8px;
        top: @mp-b;
        right: @mp-b;
        // color: @darkgrey;
        .fs-s;
        transition: .25s;

        border-radius: 50%;
        margin: @mp-a;
        position: absolute;
        width: 61px;
        height: 61px;  

        display: inline-block;
        vertical-align: top;
        span {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .fs-s;
        font-size: 15px;
        word-break: inherit;
        width: 100%;
        text-transform: uppercase;
        cursor: pointer;
        }
      }
      &_outer {
        width: 100vw;
        height: 100vh;

        position: fixed;
        left: 0;
        top: 0;

        z-index: 500000000;
        background: rgba(255,255,255,0.6);
      }    
      &_inner {
        width: calc(~"100vw - 40px");
        height: calc(~"100vh - 40px");
        margin: @mp-b;
        padding: @mp-a;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
        transition: opacity 0.25s;
        background-color: white;
        box-shadow:0 10px 3px 3px rgba(0, 0, 0, 0.05), -1px 0px 4px  rgba(0, 0, 0, 0.08) !important;3
        cursor: pointer !important;
      }
      &_portrait {
        background-size: auto 100%;
      }
      &_landscape, &_square {
        background-size: contain;
      }
      &_active {
        opacity: 1;
      }
    }
  }

  .contributions {
    padding-top: 80px;
    padding-bottom: @mp-a;
    margin-right: @mp-c;
    user-select: none;
    z-index: 10000;
    position: relative;
    &_wrapper {
      margin: 0 auto;
      max-width: 1720px;
      text-align: center;
    }
    &_button {
      text-align: center;
      user-select: none;
      .fs-l;
      letter-spacing: 1.8px;
      font-family: 'scarlaregular'; 
      span {
        // border: 2px solid;
        border-radius: 0px !important;
        padding: 5px 10px 4px 10px;
        margin: 3px;
        display: inline-block;
        background: black;
        background: @darkgrey;
        cursor: pointer;
        &:hover {
          background: @black;
          color: @midgrey;
        }
      }
    }
    &_textarea {
      margin-top: @mp-b !important;
      padding: 0 @mp-c !important;
      padding-bottom: @mp-b!important;
      &_big {
        .fs-l;
      }
    }
    &_title {
      margin-bottom: @mp-b !important;
      // .fs-l !important;
    }
    &_clear {
      cursor: pointer;
    }
    &_text {
      text-align: left;
      cursor: pointer !important;
      p {
        display: inline;
        margin: 0;
        cursor: pointer;
      }
      &_button {
        display: block !important;
        // text-decoration: underline;
        text-transform: lowercase;
        // color: @darkgrey !important;
      }
    }
    &_inner {
    margin: 0 0 @mp-c @mp-c;
    
    display: inline-block;
    vertical-align: top;
    
    background-color: @white;

    position: relative;
    cursor: pointer;

    color: @black;
      &_el {
        text-align: left;
        letter-spacing: .8px;
        position: absolute;
        padding: @mp-a;
        left: 0;
        top: 0;
        pointer-events: none;
        p {
          margin: 0;
          box-sizing: border-box;
          .fs-m;
        }
        p:last-of-type {
          .fs-s;
        }
      }
      &_text {
        text-align: left;
        padding: 0;
        margin: 0;
        p {
          padding: 0;
          margin: 0;
        }
        &:after {
          content: "click to read more";
          color: @darkgrey;
          font-size: 15px;
          letter-spacing: .8px;
        }
      }
    }
    &_singleimg {
      width: auto;
      .portrait {
        width: 160px;
        height: 220px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
      .square {
        width: 160px;
        height: 160px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
      .landscape {
        width: 220px;
        height: 160px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    &_carousel {
      width: auto;
      height: auto;
      background: transparent;
      margin: 0 0 15px @mp-c;
      &_inner {
        background-position: center;
        background-repeat: no-repeat;
        background-color: @white;

        display: inline-block;
        margin: 0 @mp-a @mp-a  0;
        position: relative;
        transition: .5s .4s;
        // &:hover {
        //   animation: wobble .8s;
        //   z-index: 10000000;
        // }
        .contributions_inner_el p {
          white-space: nowrap;
          z-index: 200000;
          display: block;
          position: relative;
        }
      }
      .portrait {
        height: 108px;
        width: 80px;
      }
      .square {
        height: 108px;
        width: 108px;
      }
      .landscape {
        height: 80px;
        width: 108px;
        vertical-align: top;
      }
    }
    &_text {
      background: transparent;
      color: @black;
      .contributions_inner_el {
        padding-left: 0;
      }
    }
  }

  .speech-bubble2 {
    width: 80px;
    padding: 10px;
    left: 20px;
    position: absolute;
    background: #353535;
    top: -80px;
    color: #cacaca;
    border-radius: 12px;
    box-shadow: -5px 2px 40px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 10px rgba(0, 0, 0, 0.3), 0 10px 20px 20px rgba(0, 0, 0, 0.2), -1px 0px 4px  rgba(0, 0, 0, 0.2) !important;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: .4px;
    transform: rotate(8deg);
    z-index: 10000000000;
    transition: 0.0001s 0.0001s;
    opacity: 1;
    cursor: default;
    transform-origin: center bottom;
    transition: .5s .5s;
    letter-spacing: 1px;
  }

  .bubble2Active {
    opacity: 0;
    pointer-events: none;
   }

  .speech-bubble2:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: -5px;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    border-bottom-color: #353535;
    border-top: 0;
    border-left: 0;
    margin-left: 34.5px;
    transform: 

    rotate(90deg); 
  }


  .buttonHolder{
  margin: 0 auto;
  padding: @mp-b 0 @mp-d 0 !important;
  text-align: center;
  transition: 0;
  }

  .button{
  background-image: -webkit-linear-gradient(top, #f4f1ee, #fff);
  background-image: linear-gradient(top, #f4f1ee, #fff);
  box-shadow: -5px 2px 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 5px rgba(0, 0, 0, 0.3), 0 10px 20px 20px rgba(0, 0, 0, 0.2), -1px 0px 4px  rgba(0, 0, 0, 0.2), inset 0px 4px 1px 1px white, inset 0px -3px 1px 1px rgba(204,198,197,.5);
  }

  .buttonNav {
  border-radius: 50%;

  margin: @mp-a;
  position: relative;
  width: 122px;
  height: 122px;  

  display: inline-block;
  vertical-align: top;
  span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  .fs-s;
  font-size: 15px;
  word-break: inherit;
  width: 100%;
  }
  }

  .button:after{
  color:#e9e6e4;
  content: "";
  display: block;
  font-size: 30px;
  height: 100px;
  text-decoration: none;
  text-shadow: 0px -1px 1px #bdb5b4, 1px 1px 1px white;
  position: absolute;
  width: 100px;
  }

  .button:hover{
  background-image: -webkit-linear-gradient(top, #fff, #f4f1ee);
  background-image: linear-gradient(top, #fff, #f4f1ee);
  }

  .button:active, .buttonActive{
  background-image: -webkit-linear-gradient(top, #efedec, #f7f4f4);
  background-image: linear-gradient(top, #efedec, #f7f4f4);
  box-shadow: 0 3px 5px 0 rgba(0,0,0,.4), inset 0px -3px 1px 1px rgba(204,198,197,.5);
  color: @darkgrey;
  }

  .button:active:after{
  color:#dbd2d2;
  text-shadow: 0px -1px 1px #bdb5b4, 0px 1px 1px white;
  }

  .typewriter-cursor {
  top: 0 !important;
  left: -4px !important;
  }

  @media screen and (max-width: @breakpoint1) {


    .buttonNav { 
      width: 90px;
      height: 90px; 
      // margin: 0 @mp-a/4;
      span {
        // font-size: 12px;
        word-break: normal;
      }
    }  

    .issue_preview_inner {
      background-size: calc(~"100% - 20px") auto;  
    }

    .issue_image {
      width: 70vw;
    }

    .multiselect__content-wrapper {
      width: calc(~"100vw - 40px");
    }

    .multiselect {
      margin: 0 auto;
      width: 100%;
      left: @mp-b;

      padding: 0;
      z-index: 1000000;

      &__select {
      position: fixed;
      width: 40px;
      height: 42px;
      right: @mp-b;
      }

      &__input {
        width: calc(~"100vw - 40px");
        .fs-m;
      }

      .multiselect__content {
        width: calc(~"100vw - 40px");
        margin-left: @mp-a;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Issue.vue